import * as React from 'react';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { DomPContainer } from './components';
export var pDefaultDomTopModelsObject = {
    PContainer: (React.createElement(TopModel, { name: "PContainer" }, DomPContainer)),
};
